import { render, staticRenderFns } from "./CompanyManagementDetail.vue?vue&type=template&id=3adcbfd7&scoped=true&"
import script from "./CompanyManagementDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyManagementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adcbfd7",
  null
  
)

export default component.exports